import { Input } from "semantic-ui-react";
import NumberInput from "./NumberInput";

const ParameterInput = ({
  label,
  value,
  min,
  max,
  step,
  onChange,
  index,
  noOfDecimals = 1,
}) => (
  <div className="parameter-input">
    <label className="parameter-label">{label}:</label>
    <Input
      type="range"
      min={min}
      max={max}
      step={step}
      value={value}
      onChange={(e) => onChange(index, parseFloat(e.target.value))}
      style={{ flex: 1, height: "20px" }}
    />
    <NumberInput
      type="number"
      step={step}
      value={isNaN(value) ? 0 : parseFloat(value?.toFixed(noOfDecimals))}
      onChange={(e) => {
        const val = e.target.value;
        if (val === "" || !isNaN(parseFloat(val))) {
          onChange(index, parseFloat(val));
        }
      }}
      className="number-input"
      style={{ width: "90px" }}
    />
  </div>
);

export default ParameterInput;
